import { render } from "./AuthLayout.vue?vue&type=template&id=3d94074b&scoped=true"
const script = {}

import "./AuthLayout.vue?vue&type=style&index=0&id=3d94074b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d94074b"]])

export default __exports__